import moment from "moment";

export const CONSENT_DATE_FORMAT = "DD MMM YYYY, hh:mm A";

/**
 * Formats backend ISO timestamps for the viewer's local timezone.
 * Evidence timezone metadata describes the record and must not affect display.
 */
export const formatConsentDate = (
  value?: string | null,
  fallback = "Date unavailable",
) => value && moment(value).isValid()
  ? moment(value).local().format(CONSENT_DATE_FORMAT)
  : fallback;
